<template>
  <div v-if="visivel" class="w3-modal" style="display: block;">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header class="w3-row-padding">
        <span @click="fechar" class="w3-button w3-display-topright">&times;</span>
        <h4 class="texto-vermelho titulo">Pesquisar Cidade</h4>
      </header>

      <div
        v-show="mostrar_filtros"
        class="w3-row-padding w3-margin-bottom">

        <div
          class="w3-left w3-padding-left w3-col"
          style="padding: 0;">

          <div class="w3-col s12 m12 l12">
            <label for="campoPesquisa">
              <span>{{tipos_pesquisa[indice_selecionado].descricao_pesquisa}}</span>
            </label>

            <input 
              type="text"
              :class="buscarClasseCampoPesquisa()"
              style="max-width: 100%; border-radius: 4px;"
              v-model="chave_pesquisa"
              id="campoPesquisa"
              autocomplete="off"
              :placeholder="tipos_pesquisa[indice_selecionado].placeholder"
              v-on:keyup="converter()"
              v-on:keyup.enter="pesquisar()"
              ref="campoPesquisa">

            <div
              class="w3-dropdown-hover w3-transparent w3-left w3-col s1 m1"
              style="margin-top: 21px;">

              <button class="w3-button texto-vermelho w3-border">
                <i class="fa fa-filter"></i>
              </button>

              <div
                style="width: 210px;"
                class="w3-dropdown-content w3-bar-block w3-border">

                <div
                  :key="tipo_pesquisa.indice"
                  v-for="tipo_pesquisa in tipos_pesquisa">

                  <button
                    class="w3-bar-item w3-button botao-quadrado"
                    @click="setChavePesquisa(tipo_pesquisa.indice)">

                    <i :class="getIconeFiltro(tipo_pesquisa.indice)"></i>
                    <span> {{tipo_pesquisa.descricao_pesquisa}}</span>
                  </button>
                </div>
              </div>
            </div>

            <div class="w3-col s9 m9 l9 w3-right">
              <button 
                class="w3-button w3-theme w3-right" 
                style="margin-top: 21px;" 
                @click="pesquisar()"
                :disabled="processando">
                <span>Pesquisar</span>
              </button>                  
            </div>

          </div>
        </div>
      </div>

      <div v-if="processando" class="w3-col s12 m12 l12">
        <div class="w3-panel w3-theme w3-card-2">
          <p>
            <i class="fa fa-sync-alt w3-spin"></i>
            <span> Processando...</span>
          </p>
        </div>
      </div>
            
      <div
        v-if="(
          mostrar_filtros &&
          (dados_filtrados.length > 0) && 
          (!processando)
        )"
        class="w3-col s12 m12 s12 w3-center">
        
        <i
          class='fas fa-caret-down' 
          @click="mostrar_filtros = false"
          style='font-size:24px; cursor: pointer;'>
        </i> 
      </div>

      <div class="w3-col s12 m12 l12 w3-left">
        <button
          class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile"
          v-if="!mostrar_filtros" v-on:click="mostrar_filtros = !mostrar_filtros">
            <i class="fa fa-filter icone-vermelho"></i>
            <span> Mostrar filtros</span>
        </button>
      </div>

      <div v-if="!mostrar_filtros">
        <div class="w3-col s12 w3-margin-top w3-margin-bottom">            
          <div
            v-show="dados_filtrados.length > 0" 
            class="w3-responsive w3-small"
            v-if="!mostrar_filtros" 
            style="max-height: calc(75vh - 300px); min-height: 200px; overflow: auto" >

            <div
              class=""
              :key="cidade.cidade_id"
              v-for="cidade in dados_filtrados"
              @click="confirmar(cidade)">

              <div
                class="w3-col card-itens w3-border w3-padding-small"
                style="cursor: pointer; white-space: normal;">
                <span>{{nPadrao(cidade.cidade_id, 0)}} - </span>
                <strong class="texto-vermelho">{{cidade.nome}}</strong>
                <span>/{{cidade.estado_id}}</span>
              </div>
            </div>

          </div>
        </div>

        <footer class="w3-container conteudo-centralizado"></footer>
      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RCidade from '@/components/Rest/RCidade';

  export default {
    name: 'PesquisaCidades',

    data() {
      return {
        visivel: false,
        chave_pesquisa: '',
        indice_selecionado: 1,

        tipos_pesquisa: [
          {
            indice: 0,
            tipo_pesquisa: 'COD',
            descricao_pesquisa: 'Código',
            placeholder: 'Digite o código'
          },

          {
            indice: 1,
            tipo_pesquisa: 'NOM',
            descricao_pesquisa: 'Nome',
            placeholder: 'Digite o nome'
          }
        ],

        processando: false,
        mostrar_filtros: true,
        dados_filtrados: []
      }
    },

    methods: {
      abrir() {
        this.visivel = true;        
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      confirmar(cidade) {
        this.$emit('confirmar', cidade);
        this.visivel = false; 
      },

      fechar() {
        this.visivel = false;
      },

      setChavePesquisa(indice) {
        let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;
        this.indice_selecionado = indice;
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      getIconeFiltro(indice) {
        if(indice == this.indice_selecionado) {
          return 'fa fa-check-square icone-vermelho';
        }

        return 'far fa-square';
      },

      converter() {
        let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;
        this.chave_pesquisa = this.chave_pesquisa.toUpperCase();
      },

      verificarDados() {
        let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;

        if (
          (tipo_selecionado == 'COD') &&
          (
            (parseInt(this.chave_pesquisa) < 0) ||
            (parseInt(this.chave_pesquisa) > 9999999999)
          )
        ) {
          toastr.error('Digite um código válido!');
          return false;
        }

        if (
          (tipo_selecionado == 'NOM') &&
          (this.chave_pesquisa.length < 2)
        ) {
          toastr.error('É necessário digitar no mínimo 2 caracteres de pesquisa!');
          return false;
        }

        return true;
      },

      async pesquisar() {
        try {
          if (!this.verificarDados()) {
            return;
          }

          let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;

          this.processando = true;
          this.dados_filtrados = [];

          let parametros = {
            tipo: tipo_selecionado,
            chave: this.chave_pesquisa
          };

          let retorno = await RCidade.pesquisarCidades(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.dados_filtrados =  retorno.dados;

          this.mostrar_filtros = false;
          this.processando = false;
        }
        catch (e) {
          this.processando = false;
          toastr.error(e.message);
        }
      },
      
      buscarClasseCampoPesquisa() {
        let retorno = 'w3-input w3-border';

        if (!Biblioteca.stringVazia(this.chave_pesquisa)) {
          let tipo_selecionado = this.tipos_pesquisa[this.indice_selecionado].tipo_pesquisa;
          retorno = retorno + ' tudo-maiusculo';
        }

        return retorno;
      },

      nPadrao(numero, casas_decimais = 2) {
        return Biblioteca.nPadrao(numero, casas_decimais);
      }
    }
  }
</script>

<style escoped>
  .card-itens{
    border-radius: 10px 10px 10px 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    border-bottom: 0px dotted #666666;
    margin-top: 5px;
  }
  
  @media screen and (min-width: 1200px) {
    .w3-modal-content {
      width: 80%;
    }
  }

  @media screen and (max-width: 1199px) {
    .w3-modal-content {
      width: 95%;
    }
  }

  .fundo-enfase {
    background-color: #dedede;
  }

  .tudo-maiusculo {
    text-transform: uppercase;
  }

</style>


// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaCidades.vue